import { IDropdownOption } from '@fluentui/react';
import { useEffect } from 'react';

import NumberField from '../../../../NumberField';
import { actions } from '../../../slice';
import { getFormState, Payment } from '../../../slice/newFormReducers';
import { getSummary } from '../utils';
import { useColumnOnChangeFn, useColumnSelector } from './hooks';

// import { useColumnSelector as useProductColumnSelector } from '../Payment/hooks';
// TODO fetch total gross if its not edited

type Props = {
  uuid: string;
  // index: number; // TODO
};

const key: keyof Payment = "amount";

export default ({ uuid }: Props) => {
  const paymentType = useColumnSelector(uuid, "type");
  const isEditingLocked = useColumnSelector(uuid, "isEditingLocked");
  const value = useColumnSelector(uuid, key);
  const onChange = useColumnOnChangeFn(uuid, key, true);

  useEffect(() => {
    if (!value && !isEditingLocked && paymentType) {
      const formVariables = getFormState();
      const summary = getSummary(formVariables);

      if (summary.unpaidTotal > 0)
        actions.setFormPaymentVariable([uuid, key, summary.unpaidTotal]);
    }
  }, [paymentType]); // shouldn't be all arguments

  return (
    <NumberField
      value={value ? value.toString() : ""}
      suffix="TL"
      onChange={onChange}
      maxLength={12}
      disabled={isEditingLocked}
    />
  );
};

const options: IDropdownOption[] = [
  { key: "TRY", text: "TRY" },
  { key: "USD", text: "USD" },
  { key: "EUR", text: "EUR" },
  { key: "GBP", text: "GBP" },
];
